import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className"];
import * as React from 'react';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
var Star02 = _ref => {
  var {
      className
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    fill: "none",
    viewBox: "0 0 24 24",
    "data-testid": "star02",
    className: clsx('stroke-current', className)
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M11.3063 3.207c.2275-.396.3413-.5938.4899-.6602a.5.5 0 0 1 .4075 0c.1487.0663.2624.2643.4899.6601l1.9551 3.4024c.0843.1465.1264.2198.1854.273a.4996.4996 0 0 0 .1807.1044c.0757.0245.1602.0243.3292.024l3.9241-.008c.4565-.001.6848-.0014.8166.0942a.5.5 0 0 1 .2037.3529c.0169.162-.0976.3594-.3267.7543l-1.9689 3.3944c-.0848.1462-.1272.2193-.1438.297a.4998.4998 0 0 0 0 .2088c.0166.0777.059.1508.1438.297l1.9689 3.3944c.2291.3949.3436.5924.3267.7543a.5001.5001 0 0 1-.2037.3529c-.1318.0956-.3601.0951-.8166.0942l-3.9241-.008c-.169-.0003-.2535-.0005-.3292.024a.5002.5002 0 0 0-.1807.1044c-.059.0532-.1011.1265-.1854.273l-1.9551 3.4024c-.2275.3958-.3412.5938-.4899.6601a.5005.5005 0 0 1-.4075 0c-.1486-.0663-.2624-.2643-.4899-.6601l-1.9551-3.4024c-.0843-.1465-.1264-.2198-.1854-.273a.5006.5006 0 0 0-.1807-.1044c-.0757-.0245-.1602-.0243-.3292-.024l-3.924.008c-.4566.0009-.685.0014-.8167-.0942a.5001.5001 0 0 1-.2037-.3529c-.017-.1619.0976-.3594.3267-.7543l1.969-3.3944c.0847-.1462.1271-.2193.1437-.297a.5005.5005 0 0 0 0-.2088c-.0166-.0777-.059-.1508-.1438-.297L4.0382 8.2041c-.229-.395-.3436-.5924-.3267-.7543a.5.5 0 0 1 .2037-.3529c.1318-.0956.36-.0951.8166-.0942l3.9241.008c.169.0003.2535.0005.3292-.024a.5.5 0 0 0 .1807-.1044c.059-.0532.1011-.1265.1854-.273l1.9551-3.4024Z"
    })
  }));
};
export default Star02;